import { CampaignStage } from '@urbanx/agx-ui-components';
import { getEnumValue } from 'helpers/enumHelper';

const propertyInformationAvailabilityStages = [
  CampaignStage.AgreementPendingCompliance,
  CampaignStage.ListingCurrent,
  CampaignStage.ListingUnderContract,
  CampaignStage.ListingUnconditional,
  CampaignStage.ListingSold,
  CampaignStage.ListingWithdrawn,
];

export const isPropertyInformationPageAvailable = (campaignStage?: string) => {
  const stage = getEnumValue(CampaignStage, campaignStage);

  return stage !== undefined && propertyInformationAvailabilityStages.includes(stage);
};
